
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"79","height":"79"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Rectángulo 25","fill":"none","d":"M0 0h79v79H0z"}}),_c('path',{attrs:{"d":"M18.912 34.507q.32.326.673.622v25.378a2.163 2.163 0 002.245 2.072h35.914a2.163 2.163 0 002.245-2.072V35.132q.353-.295.673-.622a7.8 7.8 0 001.641-7.16l-2.382-8.78A2.219 2.219 0 0057.744 17H21.83a2.219 2.219 0 00-2.178 1.57l-2.374 8.776a7.8 7.8 0 001.634 7.16zm23.12 23.929h-4.49V48.077h4.49zm13.468 0h-8.979V46a2.163 2.163 0 00-2.245-2.072h-8.978A2.163 2.163 0 0033.052 46v12.436h-8.977V37.511a9.4 9.4 0 008.785-2.673c.058.062.119.122.18.184a9.552 9.552 0 006.839 2.7 9.429 9.429 0 006.655-2.693c.061-.062.121-.122.18-.184a9.4 9.4 0 008.785 2.671zM21.631 28.351l1.952-7.207h32.408l1.953 7.208a3.955 3.955 0 01-.829 3.607 4.7 4.7 0 01-3.59 1.616 4.452 4.452 0 01-4.534-3.854l-.094-1.036a2.2 2.2 0 00-2.423-1.893 2.129 2.129 0 00-2.051 2.237 3.964 3.964 0 01-1.187 3.188 4.82 4.82 0 01-3.54 1.357 4.736 4.736 0 01-3.344-1.354 4.01 4.01 0 01-1.2-3.191 2.129 2.129 0 00-2.052-2.235 2.346 2.346 0 00-1.642.476 2 2 0 00-.78 1.416l-.094 1.036a4.453 4.453 0 01-4.532 3.852 4.7 4.7 0 01-3.59-1.616 3.955 3.955 0 01-.829-3.607z","fill":"#6c757d"}})])
          )
        }
      }
    